<script>
  export default{
    name: 'pregao-menu',
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="pmenu">
    <ul>
      <li><a>Chat</a></li>
      <li><a>Lances Automáticos</a></li>
      <li><a>Consulta Rápida</a></li>
      <li><a>Pausar Leilão</a></li>
    </ul>
    <router-link :to="{name: 'leiloes.visualizar', params: {id: $route.params.id}}" class="fechar">x</router-link>
  </div>
</template>



// WEBPACK FOOTER //
// Menu.vue?341e0940